import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, CanLoad, ActivatedRouteSnapshot, RouterStateSnapshot, Router, Route } from '@angular/router';

import { Observable } from 'rxjs';

import { LoginService } from '../login.service';
import { UserService } from '../../data/user.service';
import { Settings, SettingsService } from '../../../settings';

//@Injectable({
//  providedIn: 'root'
//})
@Injectable()
export class HasAccessGuard implements CanActivate, CanActivateChild, CanLoad  {
  private settings: Settings; 

  constructor(
    private loginService: LoginService,
    private userService: UserService,
    private settingsService: SettingsService,
    private router: Router
  ) {
    this.settings = settingsService.get();
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean{
    return this.hasAccess();
  }
  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return this.hasAccess();
  }
  canLoad(route: Route): Promise<boolean> {
    return this.hasAccess();
  }

  hasAccess(): Promise<boolean> {

    return new Promise<boolean>((resolve, reject) => {

      if (!this.settings.useIdentityServer) {

        resolve(true);

      } else {

        this.userService.hasAccess()
          .subscribe((hasAccess) => {

            if (!hasAccess)
              this.router.navigate(['/noaccess']);

            resolve(hasAccess);
          });
      }
    });
  }
}
